<script>
/**
 * CocinaeasylunchreporteQuicktable
 * 
 * @author Daniel Lepe
 * @date 16 de Agosto, 2024
 * @version 1.0
 */
import _ from 'lodash'
import { objectToUrlString } from '@/utils.js'
import { captions, quicktableFilters, baseIndex as fetchingAPI } from './archetype.js'
import modalPlanAgendaDetails from './modalPlanAgendaDetails.vue'
import CocinareporteinterrelacionQuicktable from '../Cocinareporteinterrelacion/CocinareporteinterrelacionQuicktable.vue';
import ReporteAgrupadoPorUsuario from '../Cocinareporteinterrelacion/ReporteAgrupadoPorUsuario.vue';
// import moduleNavigator from '../moduleNavigator.vue'

import QuickCardFooter from '@/views/elements/quick-card-footer.vue'
import axios from 'axios'
import automodal from './CocinaeasylunchreporteAutomodal.vue'

let name = 'CocinaeasylunchreporteQuicktable',
	newButtonLabel = 'New',
	emptyHeader = 'Data not found',
	emptyLead = 'Module empty',
	reloadData = 'Try reloading this page',
	tryAgainLater = '',
	header = 'Reporte general de cocina',
	footer = null;

export default {
	name,

	components: {
		automodal,
		QuickCardFooter,
		modalPlanAgendaDetails,
		CocinareporteinterrelacionQuicktable,
		ReporteAgrupadoPorUsuario
		// moduleNavigator
	},

	props: {
		debug: {
			type: Boolean,
			default: false
		},
		hideTermFilter: {
			type: Boolean,
			default: true
		},
		value: {
			type: [Object, Number, String]
		},
		valueName: {
			type: String,
			default: 'id'
		},
		disableNew: {
			type: Boolean,
			default: true
		},
		selectMode: {
			type: Boolean,
			default: false
		},
		hideNavigation: {
			type: Boolean,
			default: false
		},
		fetchingAPI: {
			type: String,
			default: () => { return fetchingAPI }
		},
		header: {
			type: String,
			default: () => { return header }
		},
		perPage: {
			type: Number,
			default: 500,
		},
		footer: {
			type: String,
			default: () => { return footer }
		},
		captions: {
			type: [Array, Object],
			default: () => captions
		},
		args: {
			type: Object,
			default: () => { return {} }
		}
	},

	computed: {
		getPlansSums() {
			const items = _.cloneDeep(this.items)

			// First group items by plan_id and sum their quantities
			const planTotals = _.groupBy(items, 'plan_id');

			// Create unique plans with subtotals
			return _.uniqBy(items.map(item => ({
				plan_id: item.plan_id,
				plan: item.plan,
				subtotal: _.sumBy(planTotals[item.plan_id], item => parseInt(item.cantidad)),
				subtotalPrecio: _.sumBy(planTotals[item.plan_id], item => parseInt(item.precio))
			})), 'plan_id');
		},
		cCaptions() {
			let r = [];
			try {
				if (this.selectMode) {
					r.push({
						key: 'check',
						label: ''
					})
				}
				_.forEach(this.captions, item => {
					if (item.key != 'receta' || this.filters.tipoConsulta == 'Recetas')
						r.push(item)
				})
			} catch (e) {
				console.error(e)
			}
			return r;
		},
		sourceURI() {
			let init = this.fetchingAPI + "/" + this.perPage + "/" + this.currentPage;
			try {
				if (this.term) {
					init += "/" + this.term;
				} else if (!this.term || this.term == "s") {
					init += "/@";
				}
				const fullArgs = _.merge(this.args, this.filters);
				init += '/' + objectToUrlString(fullArgs)
				return init.trim().replace(/[ ]/g, '_');
			} catch (e) {
				console.warn("sourceURI.building.error", init, e)
			}
			return init;
		}
	},

	data: () => {
		return {
			name, newButtonLabel, emptyHeader,
			emptyLead, tryAgainLater, reloadData,
			currentPage: 1,
			items: [],
			groupingDefinitions: {},
			itemsCount: 0,
			term: null, filters: {},
			isLoading: false
		}
	},

	methods: {
		print() {
			window.print();
		},
		isSelected(data) {
			// console.log('isSelected', data, this.value, (this.value == data.item[this.valueName]))
			return (this.value == data.item[this.valueName])
		},
		rowClicked(item, index, event) {
			this.$emit('setItem', item, event)
			this.$nextTick(() => {
				if (this.selectMode) {
					this.$emit('input', item[this.valueName], { item, index, event })
				} else if (this.filters.tipoConsulta == 'Planes' && !this.filters.sedeName) {
					this.$refs.modalPlanAgendaDetails.filterByPlan(item)
				}
			})
		},
		quicktableFilters,
		async refreshFromStart() {
			this.currentPage = 1
			this.refresh()
		},
		async refresh() {
			this.isLoading = true
			await Promise.all([
				this.loadUp(),
				(this.$refs.cocinareporteinterrelacionQuicktable) ? this.$refs.cocinareporteinterrelacionQuicktable.refresh() : Promise.resolve(),
				(this.$refs.ReporteAgrupadoPorUsuario) ? this.$refs.ReporteAgrupadoPorUsuario.refresh() : Promise.resolve()
			])
			this.isLoading = false
		},
		async loadUp() {
			try {
				let response = await axios.get(this.sourceURI)
				this.items = response.data.rows;
				this.itemsCount = response.data.count;
				this.groupingDefinitions = (_.isObjectLike(response.groupingDefinitions) ? response.groupingDefinitions : {});
			} catch (error) {
				this.items = [];
				this.itemsCount = 0;
				console.error(error)
			}
		}
	},

	watch: {
		currentPage(a, b) {
			this.refresh();
		},
		'$route'() {
			this.loadUp()
		}
	},

	mounted() {
		this.refresh()
	}
};
</script>

<template>
	<div :id="name">

		<div class="debug" v-if="debug">
			<pre><code>{{ filters }}</code></pre>
		</div>

		<b-card id="filters-holder">
			<b-row align-h="between">

				<b-col class="hide-on-print" v-if="!hideTermFilter">
					<b-input-group>
						<b-form-input v-model="term" @keyup.enter="refreshFromStart()" placeholder="Buscador..." />
						<b-input-group-append>
							<b-button v-if="!!term" variant="secondary" @click="term = ''; refreshFromStart();">
								<i class="fa fa-times"></i></b-button>
							<b-button variant="secondary" @click="refreshFromStart()" :disabled="!term">
								<i class="fa fa-search"></i></b-button>
						</b-input-group-append>
					</b-input-group>
				</b-col>

				<quicktable-filters v-model="filters" class="ml-3" :filters="quicktableFilters"
					disable-b-filter
					:groupingDefinitions="groupingDefinitions" @changed="refreshFromStart" />

				<b-col md="auto" class="align-right hide-on-print">
					<b-button class="mr-3" @click="print" v-if="items.length">
						<i class="fa fa-print"></i>
					</b-button>
					<automodal @refresh="refresh" :args="args" v-if="!disableNew">
						Nuevo
					</automodal>
				</b-col>

			</b-row>
		</b-card>

		<b-card id="table-content"  v-if="['Planes', 'Recetas'].includes(filters.tipoConsulta)" no-body>

			<!-- TABLE CONTENT -->
			<b-table responsive class="animated fadeIn" v-if="items.length && !isLoading" 
				@row-clicked="rowClicked"
				:hover="selectMode || (filters.tipoConsulta == 'Planes' && !filters.sedeName)" :items="items"
				:fields="cCaptions">

				<template #cell(check)="data">
					<div>
						<input type="checkbox" :checked="isSelected(data)" @click.prevent="() => { }" />
					</div>
				</template>

				<template #cell(precio)="data">
					{{ data.value | currency }}
				</template>

				<template #cell(fecha_pedido)="data">
					<strong>{{ data.value | humanizar_fecha_simple | capitalize }}</strong>
				</template>

				<template #cell(tipo)="data">
					{{ data.value | capitalize }}
				</template>

				<template #cell(cede_tipo)="data">
					{{ data.value | capitalize }}
				</template>

				<template #cell(imagenes_id)="data">
					<api-img-pristine :comp="data.value" size="128/128" :thumbnail="true" :allow-zoom="true" />
				</template>

				<template #cell(_)="data">
					<automodal :concept-id="data.item.id" @refresh="refresh" :args="args">
						Editar
					</automodal>
				</template>

				<template #cell(cantidad)="data">
					<div class="text-center">
						<strong>{{ data.value }}</strong> /
						<span class="" v-if="data.item.limiteFecha">{{ data.item.limiteFecha }} </span>
						<span class="text-warning" v-else>&infin;</span>
						unidades
					</div>
				</template>

				<template #bottom-row>
					<b-td :colspan="cCaptions.length - 3" class="text-right">
						<strong>Total:</strong>
					</b-td>
					<b-td>
						<strong>{{items.reduce((sum, item) => sum + parseInt(item.cantidad), 0)}} unidades</strong>
					</b-td>
					<b-td>
						<strong>{{items.reduce((sum, item) => sum + parseInt(item.precio), 0) | currency}}</strong>
					</b-td>
					<b-td colspan="1">&nbsp;</b-td>
				</template>

			</b-table>

			<!-- LOADING SPINNER -->

			<div v-if="isLoading">
				<div class="text-center p-5">
					<b-spinner variant="primary" />
				</div>
			</div>

			<!-- EMPTY JUMBOTRON -->

			<div v-else-if="!items.length" class="pt-4 pl-4 pr-4 pb-0">
				<b-jumbotron :header="emptyHeader" :lead="emptyLead">
					<p>{{ tryAgainLater }}</p>
					<b-button variant="primary" @click="refresh()">{{ reloadData }}</b-button>
				</b-jumbotron>
			</div>

			<!-- HEADER -->

			<template v-slot:header>
				<b-row align-h="between">

					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{ header }} - Vista general</h6>
					</b-col>

					<b-col md="auto">
						<download-as-csv-button :content="items" :headers="cCaptions" :file-name="header + ' - Vista general'" />
					</b-col>
				
				</b-row>
			</template>

			<!-- FOOTER -->

			<template v-slot:footer v-if="!isLoading && items.length">
				<quick-card-footer v-model="currentPage" class="hide-on-print" 
					:items-count="itemsCount"
					:per-page="perPage" 
					:items-fetched="items.length" 
					@refresh="refresh" />
			</template>

		</b-card>

		<cocinareporteinterrelacion-quicktable ref="cocinareporteinterrelacionQuicktable" v-if="['Vista general'].includes(filters.tipoConsulta)"
			class="mt-4" 
			:columnize-planes="(getPlansSums.length < 4)"
			:hide-sede="(filters.sedeName) ? true : false" :header="header + ' - Planes'" :args="{
				sedeName: filters.sedeName,
				fechaRango: filters.fechaRango
			}" />

		<reporte-agrupado-por-usuario  ref="ReporteAgrupadoPorUsuario" v-if="['Usuarios'].includes(filters.tipoConsulta)" class="mt-4"
			:columnize-planes="(getPlansSums.length < 4)" :hide-sede="(filters.sedeName) ? true : false"
			:header="header + ' - Agrupado por usuario'" :args="{
				sedeName: filters.sedeName,
				fechaRango: filters.fechaRango
			}" />


		<b-card no-body class="mt-4" v-if="items.length && !isLoading" bg-variant="info" text-variant="white">

			<template v-slot:header>
				<b-row align-h="between">

					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{ header }} - Subtotales por plan</h6>
					</b-col>

					<b-col md="auto">
						<download-as-csv-button :content="getPlansSums" :headers="[{key: 'plan', label: 'Plan'}, {key: 'subtotal', label: 'Subtotal'}, { key: 'subtotalPrecio', label: 'Venta' }]" :file-name="header + ' - Subtotales por plan'" />
					</b-col>
				
				</b-row>
			</template>

			<b-table responsive class="animated fadeIn" 
				:items="getPlansSums"
				:fields="['plan', 'subtotal', { key: 'subtotalPrecio', label: 'Venta' }]">

				<template #cell(subtotal)="data">
					<strong>
						{{ data.value }} unidades
					</strong>
				</template>

				<template #cell(subtotalPrecio)="data">
					<span class="text-right">
						{{ data.value | currency }}
					</span>
				</template>

				<template #bottom-row>
					<b-td class="text-right">
						<strong>Total:</strong>
					</b-td>
					<b-td>
						<strong>{{getPlansSums.reduce((sum, item) => sum + parseInt(item.subtotal), 0)}} unidades</strong>
					</b-td>
					<b-td>
						<strong>{{getPlansSums.reduce((sum, item) => sum + parseInt(item.subtotalPrecio), 0) | currency }} </strong>
					</b-td>
				</template>

			</b-table>

		</b-card>

		<modalPlanAgendaDetails ref="modalPlanAgendaDetails" @updated="refresh" />
	</div>
</template>